


















































































































































































































































































































































































import Element from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitProtectPlanData, emptyData, UnitBuiltProjectData, emptyProject, getInfo, postData, putData } from '@/api/heritageUnit/unitProtectPlan'
import { getLookupByType, DDLItem } from '@/api/common/select'
import { enFirstType, enLookupType } from '@/configs/enums'
import { validateIntKey, showVaildMsg } from '@/configs/validate'
import { tryToInt } from '@/configs/functions'
import { OfficialDocData } from '@/api/officialDoc/doc'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import hspGallery from '@/components/upload/gallery.vue'
import singleFile from '@/components/upload/singleFile.vue'
import { schemeFormat } from '@/configs/fileTypes'
import DocSelector from '@/components/officialDoc/select.vue'
import UnitBuiltProjectForm from './project.vue'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (form: { [key: string]: string }) => {
  return {
    PlanPhaseId: [{ required: true, validator: validateIntKey('请选择编制阶段'), trigger: 'change' }],
    ProtectionProjectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
    OneLevelHeight: [{ required: true, message: '请输入一类建筑控制高度', trigger: 'blur' }],
    TwoLevelHeight: [{ required: true, message: '请输入二类建筑控制高度', trigger: 'blur' }],
    ThreeLevelHeight: [{ required: true, message: '请输入三类建筑控制高度', trigger: 'blur' }],
  }
}
@Component({
  components: { FormDialog, UnitBuiltProjectForm, DocSelector, hspGallery, singleFile }
})
export default class UnitProtectPlanForm extends Vue {
  public name = 'UnitProtectPlanForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false

  public expandNames: string[] = ['base', 'projects']//, 'protection', 'monitoring', 'oneLevel', 'twoLevel', 'threeLevel']
  // get haveProject(): boolean {
  //   const has = this.form.HaveProject
  //   return has
  // }
  // set haveProject(has: boolean) {
  //   const index = this.expandNames.findIndex((v: string) => v === 'projects')
  //   if (index > -1) {
  //     this.expandNames.splice(index, 1)
  //   }
  //   if (has) {
  //     this.expandNames.push('projects')
  //   }
  //   this.form.HaveProject = has
  // }
  public loading: boolean = false
  public schemeExt: string = schemeFormat
  //保护规划文本
  public hasText: boolean = false
  //保护规划图纸
  public hasDrawing: boolean = false
  //专项评估图
  public hasAssessment: boolean = false
  //专项规划图
  public hasPicture: boolean = false
  public planPhaseList: DDLItem[] = []
  public form: UnitProtectPlanData = Object.assign({}, emptyData)
  public rules = getFormRules(this.form)
  public $refs!: {
    formData: Element.Form
    sfText: singleFile
    sfDrawing: singleFile
    gyAssessment: hspGallery
    gyPicture: hspGallery
  }
  get yearMonth(): string {
    const f = this.form
    var data = ''
    if (f.PlanYear > 0 && f.PlanMonth > 0) {
      data = f.PlanYear.toString() + '-' + f.PlanMonth.toString()
    }
    return data
  }
  set yearMonth(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.PlanYear = tryToInt(sp[0])
      f.PlanMonth = tryToInt(sp[1])
    }
    else {
      f.PlanYear = f.PlanMonth = 0
    }
  }
  public onFileChange(data: { opts: UploadOptData, file: AttachInfo }) {
    const opt = data.opts
    const hasFile = data.file.Id > 0
    const f = this.form
    switch (opt.refType) {
      case f.AttachTypeText:
        this.hasText = hasFile
        break
      case f.AttachTypeDrawing:
        this.hasDrawing = hasFile
        break
      default:
        break
    }
  }
  public onGalleryChange(data: { opts: UploadOptData, files: AttachInfo[] }) {
    const list = data.files
    const hasFiles = list && list.length > 0
    const opt = data.opts
    const f = this.form
    switch (opt.refType) {
      case f.AttachTypeAssessment:
        this.hasAssessment = hasFiles
        break
      case f.AttachTypePicture:
        this.hasPicture = hasFiles
        break
      default:
        break
    }
  }
  public getDoc(info: { data: OfficialDocData, refTo: string }) {
    const docId = info.data.Id
    if (info.refTo === 'plan') {
      this.form.PlanDocId = docId
    }
    if (info.refTo === 'publish') {
      this.form.GovernmentPublishDocId = docId
    }
  }
  public addProject() {
    let item: UnitBuiltProjectData = Object.assign({}, emptyProject)
    item.ProtectPlanId = this.form.Id
    this.projectIndex = -1
    this.showProjectForm(item)
  }
  public projectIndex: number = -1
  public editProject(index: number) {
    this.projectIndex = index
    const item = this.form.ProjectList[index]
    this.showProjectForm(item)
  }
  public removeProject(index: number) {
    this.$confirm(`确定要删除吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.form.ProjectList.splice(index, 1)
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '操作已取消'
        })
      })
  }
  public showProjectForm(data: UnitBuiltProjectData) {
    window.eventBus.$emit('openUnitBuiltProjectForm', data)
  }
  public closeProjectForm() {
    console.log('closeUnitBuiltProjectForm')
  }
  public updateProject(data: UnitBuiltProjectData) {
    if (this.projectIndex >= 0) {
      this.$set(this.form.ProjectList, this.projectIndex, data)
    }
    else {
      this.form.ProjectList.push(data)
    }
    this.projectIndex = -1
  }
  public created() {
  }
  public fetchSource() {
    const firstType = enFirstType.Select
    if (this.planPhaseList.length === 0) {
      getLookupByType(enLookupType.ProtectPlanStage, firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.planPhaseList = data
        }
      })
    }
  }
  public mounted() {
    window.eventBus.$on("openUnitProtectPlanForm", (info: { unitId: number, dataId: number }) => {
      this.expandNames = ['base', 'projects']
      this.fetchSource()
      this.fetchData(info)
    })
    window.eventBus.$on('submitUnitBuiltProjectForm', (data: UnitBuiltProjectData) => {
      this.updateProject(data)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("openUnitProtectPlanForm")
    window.eventBus.$off('submitUnitBuiltProjectForm')
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchData(info: { unitId: number, dataId: number }) {
    this.open()
    this.form = Object.assign({}, emptyData)
    this.loading = true
    getInfo(info.dataId).then((response: { data: any }) => {
      this.form = response.data
      if (info.dataId === 0) {
        this.form.UnitId = info.unitId
      }
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public sendData(data: UnitProtectPlanData) {
    window.eventBus.$emit("submitUnitProtectPlanForm", {
      data: data
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        const promist = f.Id > 0 ? putData(f.Id, f) : postData(f)
        promist.then((response: { data: any }) => {
          const data = response.data
          const msg = this.form.Id > 0 ? '保存' : '创建'
          if (data && !data.IsError) {
            this.$message({
              message: `${msg}成功`,
              type: 'success'
            })
            this.sendData(f)
            this.close()
          } else {
            this.$message({
              dangerouslyUseHTMLString: true, message: `${data.Message}`,
              type: 'warning'
            })
            console.log(response)
          }
        }, (data: any) => {
          console.log(data)
        })
      }
      else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
